// Customer reviews. Seeded with representative reviews (the client can replace these
// with their real Google/Talabat reviews). Customer-added reviews persist locally in
// demo; at go-live they'd be stored in Firestore and moderated.
export interface Review {
  id: string;
  name: string;
  rating: number; // 1–5
  text: string;
  textAr?: string;
  ts: number;
}

export const SEED_REVIEWS: Review[] = [
  {
    id: "s1",
    name: "Ahmad K.",
    rating: 5,
    text: "Best chicken biryani in Salmiya — hot, fresh and delivered fast.",
    textAr: "أفضل برياني دجاج في السالمية — ساخن وطازج ووصل بسرعة.",
    ts: 1,
  },
  {
    id: "s2",
    name: "Fatima A.",
    rating: 5,
    text: "The daily fresh trays are amazing. Karahi was full of flavour.",
    textAr: "صواني اليوم الطازجة رائعة. الكراهي كان مليئاً بالنكهة.",
    ts: 2,
  },
  {
    id: "s3",
    name: "Mohammed S.",
    rating: 4,
    text: "Great sweets and quick delivery to Fahaheel. Will order again.",
    textAr: "حلويات ممتازة وتوصيل سريع للفحيحيل. سأطلب مرة أخرى.",
    ts: 3,
  },
  {
    id: "s4",
    name: "Sara N.",
    rating: 5,
    text: "Ordered prawns masala and paneer — both excellent. Fast delivery lived up to its name.",
    textAr: "طلبت روبيان مسالا وبانير — كلاهما ممتاز. التوصيل السريع عند حسن الظن.",
    ts: 4,
  },
  {
    id: "s5",
    name: "Yousef H.",
    rating: 5,
    text: "Easy to order, clear delivery fee, and the food arrived warm. Highly recommend.",
    textAr: "الطلب سهل، رسوم التوصيل واضحة، والطعام وصل دافئاً. أنصح به بشدة.",
    ts: 5,
  },
  {
    id: "s6",
    name: "Layla M.",
    rating: 4,
    text: "Lovely gulab jamun and rasmalai. Sweets were fresh and not too sugary.",
    textAr: "جلاب جامون ورسملاي رائعة. الحلويات طازجة وليست شديدة الحلاوة.",
    ts: 6,
  },
];

const KEY = "kb_reviews";

function loadAdded(): Review[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Review[]) : [];
  } catch {
    return [];
  }
}

export function getReviews(): Review[] {
  return [...loadAdded(), ...SEED_REVIEWS].sort((a, b) => b.ts - a.ts);
}

export function addReview(r: { name: string; rating: number; text: string }): void {
  const list = loadAdded();
  list.unshift({
    id: "u" + Date.now(),
    name: r.name.trim() || "Guest",
    rating: Math.min(5, Math.max(1, Math.round(r.rating))),
    text: r.text.trim(),
    ts: Date.now(),
  });
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 30)));
  } catch {
    /* ignore */
  }
}

export function ratingSummary(): { avg: number; count: number } {
  const all = getReviews();
  if (!all.length) return { avg: 0, count: 0 };
  const avg = all.reduce((s, r) => s + r.rating, 0) / all.length;
  return { avg: Math.round(avg * 10) / 10, count: all.length };
}
